import { UserFriendlyError } from "../../../../../common/utils/base_error";
import { IUpdateColetaPrecoUseCase } from "../../../presentation/useCases/update/update_coleta_preco_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * UpdateColetaPrecoUseCase
 */

export class UpdateColetaPrecoUseCase implements IUpdateColetaPrecoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async updateColetaPreco(
    idColetaPreco: number,
    status: number,
    dataCadastro: Date,
    idRequisicaoCompra: number | undefined,
    dataColeta: Date | undefined,
    idSubconta: number | undefined,
    idFuncionarioComprador: number | undefined,
    idFuncionarioAprovadores: number[] | undefined,
    arquivo1: File | undefined,
    limparArquivo1: boolean,
    arquivo2: File | undefined,
    limparArquivo2: boolean,
    arquivo3: File | undefined,
    limparArquivo3: boolean,
  ): Promise<void> {
    if (idRequisicaoCompra === undefined) throw new UserFriendlyError('O campo "Nº da Requisição" deve ser preenchido!');
    await this.repository.updateColetaPreco(
      idColetaPreco,
      status,
      dataCadastro,
      idRequisicaoCompra,
      dataColeta ?? null,
      idSubconta ?? null,
      idFuncionarioComprador ?? null,
      idFuncionarioAprovadores && idFuncionarioAprovadores.length > 0 ? idFuncionarioAprovadores : null,
      arquivo1 ?? null,
      limparArquivo1,
      arquivo2 ?? null,
      limparArquivo2,
      arquivo3 ?? null,
      limparArquivo3,
    );
  }
}
